import { StatusIconCircleInfo } from '@energy-retailer/icons';

import { Icon } from '@/components/icon';

import type { InfoBoxProps } from './alert.types';

const InfoTag = ({ icon, children }: InfoBoxProps) => {
  return (
    <div
      className="flex gap-b"
      role="alert"
    >
      <div>
        <Icon
          className="h-icon w-icon text-pink"
          icon={
            icon ? (
              icon
            ) : (
              <StatusIconCircleInfo data-testid="StatusIconCircleInfo icon" />
            )
          }
        />
      </div>
      <div className="flex items-center justify-center">{children}</div>
    </div>
  );
};

export default InfoTag;
